import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';
import { Image, Row, Col} from 'react-bootstrap';
import GoogleTagManagerIcon from 'src/legacy/images/google_tag_manager.svg';
import GoogleTagManagerActivationPage from './GoogleTagManagerActivationPage';
import DeactivateIntegrationContainer from "src/legacy/components/DeactivateIntegration/index";
import BackButton from 'src/legacy/components/BackButton';
import { localizedStrings } from 'src/localization/index.jsx';
import { shouldFetchIntegrations } from 'src/legacy/redux/actions/integrations';

class GoogleTagManagerView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props){
    super(props);
    this.state={
      deleteConfirmation: false
    }

    this._handleDeactivateClicked = this._handleDeactivateClicked.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedGoogleTagManager = localizedStrings.components.integrations.google_tag_manager;
 
  }

  _handleDeactivateClicked(){
    this.setState({
      deleteConfirmation: true
    })
  }

  componentDidMount(){

    if(shouldFetchIntegrations(this.props.integrations)) {
      this.props.fetchIntegrations();
    }
  }
  
  render(){
    return (
      <div className={styles.content} fluid>
        <Row className={styles.row}>
          <Col md={3} className={styles.left}>
            <BackButton className={styles.back} title={this.localizedCommons.actions.back} onClick={() => {
              this.props.navigate('/settings/integrations');
            }} />
            <div className={ styles.heading }>
              <Image src={GoogleTagManagerIcon} />
              <h2 className={styles.name}>{ this.localizedGoogleTagManager.title }</h2>
              <p className={styles.description}>{ this.localizedGoogleTagManager.sub_text }</p>
              { this.props.integration &&
                <button className={styles.button}  onClick={this._handleDeactivateClicked}>
                  { this.localizedIntegrations.actions.deactivate }
                </button>
              }
            </div>  
          </Col>
          <Col md={9} className={styles.right}>
            <GoogleTagManagerActivationPage store={this.context.store} integration = { this.props.integration } activeIntegrations = {this.props.activeIntegrations}/>  
          </Col>
        
        </Row>
        <DeactivateIntegrationContainer 
          name = { this.localizedGoogleTagManager.title }
          type="google-tag-manager"
          message={ this.localizedGoogleTagManager.deactivate_slider.sub_text }
          show={this.state.deleteConfirmation}
          onCancel={()=> {
          this.setState({
             deleteConfirmation: false
          })
        }}
       />   
      </div>
    );
  }
}

export default GoogleTagManagerView;